import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'
import { StaticFileIconsConstant } from '../constants'

export type File = FileGoogle | FileMS

export type FileGoogle = {
  name: string
  url: string
  type: keyof (typeof StaticFileIconsConstant)['Google' | 'Microsoft']
  id: string
}

export type FileMS = {
  name: string
  url: string
  type: keyof (typeof StaticFileIconsConstant)['Google' | 'Microsoft']
  id: string
  driveId: string
  siteUrl: string
  resourceUrl: string
}

type InitialState = File | null

const initialState: InitialState = null as File | null

const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    setFile: (_, { payload }: PayloadAction<File>) => {
      return payload
    },
    clearFile: () => {
      return null
    },
  },
})

export const { setFile, clearFile } = fileSlice.actions

export const selectFile = (state: RootState) => state.file

export default fileSlice
